var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GraphDialog',{ref:"dialog",attrs:{"title":"Seleziona Cartella"}},_vm._l((_vm.folders),function(folder,i){return _c('div',{key:i,staticClass:"graph_folder_picker clickable",on:{"click":function($event){return _vm.select(folder)}}},[_c('GraphIcon',{attrs:{"icon":"folder"}}),_c('span',[_vm._v(_vm._s(folder.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }